import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/homeImg/r1.jpg'
import _imports_1 from '@/assets/img/homeImg/r2.jpg'
import _imports_2 from '@/assets/img/homeImg/r3.jpg'
import _imports_3 from '@/assets/img/homeImg/r4.jpg'
import _imports_4 from '@/assets/img/vccore.webp'
import _imports_5 from '@/assets/img/about1.webp'
import _imports_6 from '@/assets/img/about2.webp'
import _imports_7 from '@/assets/img/handset.webp'
import _imports_8 from '@/assets/img/addr.png'
import _imports_9 from '@/assets/img/addrs.webp'


const _withScopeId = n => (_pushScopeId("data-v-5bac3d64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "carousel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "botton" }
const _hoisted_8 = { class: "aboutVCcore" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-5bac3d64><img src=\"" + _imports_4 + "\" alt=\"\" data-v-5bac3d64></div><div class=\"aboutContent\" data-v-5bac3d64><img src=\"" + _imports_5 + "\" alt=\"\" data-v-5bac3d64><img src=\"" + _imports_6 + "\" alt=\"\" data-v-5bac3d64><img src=\"" + _imports_7 + "\" alt=\"\" data-v-5bac3d64></div>", 2)
const _hoisted_11 = { class: "download" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "addr" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "VCcore为客户提供"),
  /*#__PURE__*/_createElementVNode("h5", null, "便捷、安全、快速的全球网络体验"),
  /*#__PURE__*/_createElementVNode("div", { class: "addr-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_8,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_9,
      alt: ""
    })
  ])
], -1))

import Download from '@/components/Download/download.vue';
    import { onMounted } from '@vue/runtime-dom';
    import { useRoute } from 'vue-router'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

    document.title = 'Vccore';
    let route = useRoute();

    let toDownload = ()=>{// 回到下载地址位置
        let addr = document.querySelector('.aboutVCcore .addr')!;
        let addrHeight = <HTMLElement>addr;
        // document.documentElement.scrollTop = document.documentElement.scrollHeight - window.innerHeight - addrHeight.offsetHeight;
        setTimeout(()=>{
            window.scrollTo({
                top: document.documentElement.scrollHeight - window.innerHeight - addrHeight.offsetHeight,
                behavior: 'smooth'
            })
        },500)
    }
    // 安全认证
    let visit = ()=>window.location.href="http://vccamp.vccore.com/vccore/dist/#/";

    onMounted(()=>{
        route.query.goHome == 'to' && toDownload();
    })

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_botton = _resolveComponent("botton")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_swipe, {
        class: "my-swipe",
        autoplay: 3000,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_swipe_item, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_van_swipe_item, null, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_van_swipe_item, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_van_swipe_item, null, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_botton, { onClick: _unref(toDownload) }, {
        default: _withCtx(() => [
          _createTextVNode("免费试用")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_botton, { onClick: _unref(visit) }, {
        default: _withCtx(() => [
          _createTextVNode("安全认证")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(Download)
      ]),
      _hoisted_12
    ])
  ]))
}
}

})